import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};
const SvgEditIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      {...props}
    >
      <path
        d="M21.966 12.842a.17.17 0 0 0-.241 0L9.567 25l-.075.075a.511.511 0 0 0-.142.283l-.883 5.784a.362.362 0 0 0 .408.408l5.783-.883a.511.511 0 0 0 .284-.142l.075-.075 12.158-12.158a.171.171 0 0 0 0-.242l-5.2-5.2-.009-.008ZM31.517 12.442c0-.442-.192-.867-.5-1.184L28.74 8.983a1.716 1.716 0 0 0-1.183-.5l-1.233-.025a.522.522 0 0 0-.375.15l-2.367 2.367a.171.171 0 0 0 0 .242l5.2 5.2a.171.171 0 0 0 .242 0l2.367-2.367c.1-.1.15-.233.15-.375l-.026-1.233Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};
export default SvgEditIcon;
